import {Text} from '#component/base';

import {ActionPlanAdjustmentListProps} from './ActionPlanAdjustmentList.types';

import * as css from './ActionPlanAdjustmentList.css';

/**
 * `ActionPlanAdjustmentList` renders a list of adjustments
 * (ie "recommended courses of action") for an Action Plan.
 */
export const ActionPlanAdjustmentList = ({
  adjustments = [],
  variant = 'primary',
  ...otherProps
}: ActionPlanAdjustmentListProps) => (
  <ul {...otherProps}>
    {adjustments.map(({healthFactorAssessment, recommendedResponse, id}) => {
      const {title} = healthFactorAssessment?.healthFactor || {};

      return !!recommendedResponse ? (
        <Text
          as="li"
          className={css.listItem({borderless: adjustments.length === 1, variant})}
          color="deepBurgundy"
          key={id}>
          {title && <span>{`${title}: `}</span>}
          <Text color="inherit" fontWeight="semiBold">
            {recommendedResponse}
          </Text>
        </Text>
      ) : null;
    })}
  </ul>
);
